import React, { createElement } from 'react'
import moduleCss from './index.module.scss'

export interface TimelineProps {
    nodeId?: string
    style?: object // 容器样式

    timelineList: {
       title: string,
       desc?: string,
       url?: string
    }[]

    dotWidth?: number
    dotHeight?: number
    isDotSolid?: boolean,
    dotColor?: string
    dotBorderWidth?: number
    dotLineWidth?: number
    dotLineColor?: string

    titleHoverColor?: string
    titleStyle?: object

    descStyle?: object
}

const Timeline: React.FC<TimelineProps> = (props) => {
    const {
        nodeId, style, timelineList,
        dotWidth, dotHeight, dotBorderWidth, dotColor, isDotSolid, dotLineWidth, dotLineColor,
        titleHoverColor, titleStyle, descStyle
    } = props

    return (
        <ul id={nodeId} class={moduleCss.timeline} style={{ ...style }}>
            {
                timelineList.map((time, index) => {
                    return (
                        <li class={moduleCss.item}>
                            <div className={moduleCss.tail} style={{ borderWidth: `${dotLineWidth}px`, borderColor: dotLineColor, ...(index === timelineList.length - 1 ? { border: 'none' } : {}) }}>
                                <div
                                    className={moduleCss.dot}
                                    style={{
                                        width: `${dotWidth}px`,
                                        height: `${dotHeight}px`,
                                        borderWidth: `${dotBorderWidth}px`,
                                        borderColor: dotColor,
                                        backgroundColor: isDotSolid ? 'transparent' : dotColor,
                                        left: `-${dotWidth / 2}px`,
                                        top: `-${dotHeight}px`,
                                    }}
                                />
                            </div>

                            <div className={moduleCss.content}>
                                <div style={{ ...titleStyle }}>
                                    {
                                        time?.url
                                            ? <a href={time?.url} target="_blank" style={{ '--hover-color': titleHoverColor, }}>{time?.title}</a>
                                            : time?.title
                                    }
                                </div>
                                <div style={descStyle}>{time?.desc}</div>
                            </div>
                        </li>
                    )
                })
            }
        </ul>
    )
}

export default Timeline
